import React, { useEffect, useState } from 'react';
import { Loader2, Bookmark, AtSign } from 'lucide-react';

// Bell panel: every job comment that tags me (self-tags + teammates' @mentions).
export const MyTagsList = ({ api, onOpen }) => {
  const [tags, setTags] = useState(null);
  useEffect(() => {
    api.get('/moving-comments/my-tags').then(({ data }) => setTags(data.tags || [])).catch(() => setTags([]));
  }, [api]);

  if (tags === null) return <div className="p-4 flex justify-center"><Loader2 className="w-4 h-4 animate-spin text-slate-500" /></div>;
  if (!tags.length) {
    return <p className="p-4 text-center text-slate-500 text-sm" data-testid="my-tags-empty">No tags yet. Type @me in a job comment to save a note for yourself.</p>;
  }
  return tags.map((t) => (
    <button key={t.comment_id} type="button" onClick={() => onOpen(t.job_id)}
      className="w-full text-left p-3 border-b border-slate-800 hover:bg-slate-800" data-testid={`my-tag-${t.comment_id}`}>
      <div className="flex items-start gap-2">
        {t.self_tag ? <Bookmark className="w-3.5 h-3.5 mt-0.5 text-amber-400" /> : <AtSign className="w-3.5 h-3.5 mt-0.5 text-sky-400" />}
        <div className="flex-1 min-w-0">
          <p className="text-white text-sm font-medium truncate">Job {t.job_number || t.job_id}{t.customer_name ? ` · ${t.customer_name}` : ''}</p>
          <p className="text-slate-400 text-xs mt-1 line-clamp-2">{t.text}</p>
          <p className="text-slate-500 text-xs mt-1">
            {t.self_tag ? 'Self-tag' : `From ${t.author_name || 'teammate'}`} · {t.created_at && new Date(t.created_at).toLocaleString()}
          </p>
        </div>
      </div>
    </button>
  ));
};
